import { useState } from 'react';
import CustomModal from './CustomModal';
import ProductCards from './ProductCards';
import { AllowedProductProps } from '../interface/interface';

export function AllowedProducts(props: AllowedProductProps) {
  const [visible, setVisibility] = useState(false);

  return (
    <>
      <button
        className="mt-2 px-5 py-3 flex w-full text-white 
bg-secondary-cornflowerblue-600 border border-secondary-cornflowerblue-600 
disabled:bg-slate-400 disabled:border-slate-400 disabled:text-white disabled:cursor-not-allowed 
hover:text-secondary-cornflowerblue-600 hover:bg-white font-semibold rounded-lg text-sm justify-center"
        onClick={() => setVisibility(true)}
      >
        Order Allowed Product
      </button>
      <CustomModal
        isOpen={visible}
        onClose={() => setVisibility(false)}
        header={''}
        footer={''}
        modalSize="w-11/12 sm-land:w-3/4 md:w-3/5 lg:w-2/5 2xl:w-1/4 3xl:w-1/5"
      >
        <div>
          <p className="mb-3 text-sm font-regular text-primary-blue-500 text-left">
            Alternate Product for:{' '}
            <span className="font-semibold">{props.product.name}</span>
          </p>
          {props.product.allowedProducts.map(
            (allowedProduct: any, index: number) => (
              <ProductCards
                product={allowedProduct}
                addProductToCart={async (id: string) =>
                  props.addProductToCart(id, props.product.product_code)
                }
                removeProductFromCart={async () => {
                  props.removeProductFromCart(props.product.product_code);
                }}
                substitueCard={true}
                isAccessories={false}
                allowedProduct={false}
                key={index}
              />
            ),
          )}
        </div>
      </CustomModal>
    </>
  );
}
